// Baseball position lists — single source of truth shared across setup pages.
export const POSITIONS = ["P", "C", "1B", "2B", "3B", "SS", "LF", "CF", "RF"];
export const NON_PITCHER_POSITIONS = ["C", "1B", "2B", "3B", "SS", "LF", "CF", "RF"];

// Positions a ROSTER SLOT may be set to. DH is a real lineup slot but is not a
// fielding position, so it is absent from POSITIONS — and the roster builder's
// dropdown was rendering POSITIONS while new slots defaulted to "DH". A <select>
// whose value matches no option renders the FIRST option, so the control showed
// "P" while the slot was still DH: clicking "P" changed nothing, and the reroll
// filled from the DH pool (any non-pitcher). Keep this list and the slot's
// possible values in step.
export const SLOT_POSITIONS = [...POSITIONS, "DH"];

// Display order for auto-sorting a roster. Pitchers first, then the infield in
// defensive order, then the outfield, then DH.
export const POSITION_GROUP_ORDER = ["P", "C", "1B", "2B", "3B", "SS", "LF", "CF", "RF", "DH"];
export const positionRank = (pos) => {
  const i = POSITION_GROUP_ORDER.indexOf(pos);
  return i === -1 ? POSITION_GROUP_ORDER.length : i;   // unset sorts last
};
